import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import InputGroup from "react-bootstrap/InputGroup";

// Imports (door Tom)
import FormControl from "react-bootstrap/FormControl";
import Form from "react-bootstrap/Form";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import CardGroup from "react-bootstrap/CardDeck";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";

import { FaCheck } from "react-icons/fa";

import PageControl from "../components/PageControl";
import { formatURL, formatLines } from "../utils/utils";

import DesignStepToolTip from "./tooltips/DesignStepToolTip";
import { FormCheck, OverlayTrigger, Popover } from "react-bootstrap";

import ApiRequest from "../utils/ApiRequest";
import Loading from "../components/Loading";
import PulseLoading from "../components/PulseLoading";

function SidePanel(props) {

  const [showOrderPopup, setShowOrderPopUp] = useState(false);
  const [hideInvoiceAddress, setHideInvoiceAddress] = useState(true);
  const [orderErrors, setOrderErrors] = useState({});
  const [inputBoxDimensions, setInputBoxDimensions] = useState(props.boxDimensions);
  const [pageControlAllowNext, setPageControlAllowNext] = useState(true);
  const [showErrors, setShowErrors] = useState(false);
  const [showLast, setShowLast] = useState(false);
  let panelContent;
  let panelTitle;
  let pageControl = <PageControl page={props.designstep} prevPage={props.prevPage} nextPage={props.nextPage} handleOrderPopup={handleOrderPopup} allowNext={pageControlAllowNext} />;
  let hasDoors = false;
  let bestellenKnop = true;
  let plintBoven = "Plint Boven:";
  let plintOnder = "Plint Onder:";
  const [formData, setFormData] = useState({ email: ""});
  const [moduleBreedte, setModuleBreedte] = useState("52");
  const [isShown, setIsShown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showSchuinenkant, setShowSchuinenkant] = useState(false);
  const delayWait = ms => new Promise(res => setTimeout(res, ms));

  const onModuleBreedteChange = ({ target: { value } }) => {
    setModuleBreedte(value);
    props.setBoxDimensions("MB", value);
    inputBoxDimensions.MB = value;
    console.log("module breedte veranderd");
    props.setModuleBreedteClicked(true);
  };

  //const ontworpenKasten = () => {
  //  let path = 'https://bouwjekast.be/webshop/mijn-kasten/'; 
  //  let history = useHistory();
  //  history.push(path);
  //}

  //const nieuwOntwerp = () => {}
  
  const filteredModules = filterModules(props.modules);

  const handleSubmit = async (e) => {
    console.log("testLast");
    setLoading(false);
    e.preventDefault();
    if (_controleEmail(e)) {
      console.log("... before submitOrder ... " + e.target);
      props.submitOrder(e);
      console.log("... after submitOrder ...");
      setLoading(true);
      console.log("... before wait ... " + e.target);
      await delayWait(5000);
      console.log("... after wait ... " + e.target);
      setShowOrderPopUp(false);
      setShowLast(true);
    }
  };


  function testing2(event) {
    console.log("testing2");
  }
  
  function filterModules(modules) {
    const filteredModules = {
      single: {
        open: [],
        doorLeft: [],
        doorRight: []
      },
      double: {
        open: [],
        doors: []
      },
    }

    modules.single.forEach(module => {

      // Single Module
      String(module.module_kps_name).split('_').forEach(section => {
        if (section.includes("D") || section.includes("open")) {
          switch (section) {
            case "open": filteredModules.single.open.push(module); break;
            case "D1L": filteredModules.single.doorLeft.push(module); break;
            case "D1R": filteredModules.single.doorRight.push(module); break;
            default:
              console.log("Unable to filter module: " + module.module_kps_name);
          }
        }
      });
    });
    modules.double.forEach(module => {
      // Double Module
      String(module.module_kps_name).split('_').forEach(section => {
        if (section.includes("D") || section.includes("open")) {
          switch (section) {
            case "open": filteredModules.double.open.push(module); break;
            case "D2": filteredModules.double.doors.push(module); break;
            default:
              console.log("Unable to filter module: " + module.module_kps_name);
          }
        }
      })
    });

    return filteredModules;
  }


  console.log(props.materials);
  console.log(props.boxDimensions);

  function setMaterial(data, side) {
    if (side === "in") props.setInnerMaterial(data)
    else props.setOuterMaterial(data)

    // props.updatePrice()
  }

  function handleErrors(show) {	
    setShowErrors(show);
  }

  function handleLast(show) {
    setShowLast(show);
  }

  function _controleEmail(event) {
    console.log("event target: " + event.target);
    let customer = { email: "" }
    let errors = {};
    let formIsValid = true;

    let formData = new FormData(event.target);
    let customerEmail = formData.get("customer_email");
    let herhaalEmail = formData.get("herhaal_email");
    props.formErrors["customer_email"] = "";
    props.formErrors["herhaal_email"] = "";

    if (customerEmail !== "") {
      customer.email = customerEmail;
    } 
    else {
      errors["customer_email"] = "E-mail is een verplicht veld";
      props.formErrors["customer_email"] = "E-mail is een verplicht veld";
    }
    if (herhaalEmail !== "") {
    } 
    else {
      errors["herhaal_email"] = "Herhaal E-mail is een verplicht veld";
      props.formErrors["herhaal_email"] = "Herhaal E-mail is een verplicht veld";
    }
    if (customerEmail != herhaalEmail) {
      errors["herhaal_email"] = "Beide E-mails zijn niet gelijk";
      props.formErrors["herhaal_email"] = "Beide E-mails zijn niet gelijk";
    }

    if (Object.keys(errors).length > 0) {
      formIsValid = false;
    }
    setOrderErrors(errors);

    return formIsValid;
  }
  
  function _validCustomerForm(event) {
    let customer = { name: "", email: "", phone: "", btw: "", delivery_street: "", delivery_number: "", delivery_zip: "", delivery_city: "", invoice_street: "", invoice_number: "", invoice_zip: "", invoice_city: "" }
    let errors = {};
    let formIsValid = true;

    let formData = new FormData(event.target)

    let customerName = formData.get("customer_name");
    let customerEmail = formData.get("customer_email");
    let customerPhone = formData.get("customer_phone");
    let customerBtw = formData.get("customer_btw");

    let customerDeliveryStreet = formData.get("customer_delivery_street");
    let customerDeliveryNumber = formData.get("customer_delivery_number");
    let customerDeliveryZip = formData.get("customer_delivery_zip");
    let customerDeliveryCity = formData.get("customer_delivery_city");

    let customerInvoiceEqualsDelivery = formData.get("customer_invoice_equals_delivery");

    let customerInvoiceStreet = formData.get("customer_invoice_street");
    let customerInvoiceNumber = formData.get("customer_invoice_number");
    let customerInvoiceZip = formData.get("customer_invoice_zip");
    let customerInvoiceCity = formData.get("customer_invoice_city");

    props.formErrors["customer_name"] = "";
    props.formErrors["customer_email"] = "";
    props.formErrors["customer_phone"] = "";
    props.formErrors['customer_delivery_street'] = "";
    props.formErrors['customer_delivery_number'] = "";
    props.formErrors['customer_delivery_zip'] = "";
    props.formErrors['customer_delivery_city'] = "";
    props.formErrors['customer_invoice_street'] = "";
    props.formErrors['customer_invoice_number'] = "";
    props.formErrors['customer_invoice_zip'] = "";
    props.formErrors['customer_invoice_city'] = "";

    if (customerName !== "") {
      customer.name = customerName;
    } else {
      errors["customer_name"] = "Naam is een verplicht veld";
      props.formErrors["customer_name"] = "Naam is een verplicht veld";
    }

    if (customerEmail !== "") {
      customer.email = customerEmail;
    } else {
      errors["customer_email"] = "E-mail is een verplicht veld";
      props.formErrors["customer_email"] = "E-mail is een verplicht veld";
    }

    if (customerPhone !== "") {
      customer.phone = customerPhone;
    } else {
      errors["customer_phone"] = "Telefoon is een verplicht veld";
      props.formErrors["customer_phone"] = "Telefoon is een verplicht veld";
    }


    customer.btw = customerBtw;

    // Delivery (Bezorg)
    if (customerDeliveryStreet !== "") {
      customer.delivery_street = customerDeliveryStreet;
    } else {
      errors['customer_delivery_street'] = 'Straatnaam is een verplicht veld';
      props.formErrors['customer_delivery_street'] = 'Straatnaam is een verplicht veld';
    }

    if (customerDeliveryNumber !== "") {
      customer.delivery_number = customerDeliveryNumber;
    } else {
      errors['customer_delivery_number'] = 'Huisnummer en/of bus is een verplicht veld';
      props.formErrors['customer_delivery_number'] = 'Huisnummer en/of bus is een verplicht veld';
    }

    if (customerDeliveryZip !== "") {
      customer.delivery_zip = customerDeliveryZip;
    } else {
      errors['customer_delivery_zip'] = 'Postcode is een verplicht veld';
      props.formErrors['customer_delivery_zip'] = 'Postcode is een verplicht veld';
    }

    if (customerDeliveryCity !== "") {
      customer.delivery_city = customerDeliveryCity;
    } else {
      errors['customer_delivery_city'] = 'Gemeente is een verplicht veld';
      props.formErrors['customer_delivery_city'] = 'Gemeente is een verplicht veld';
    }

    if (!customerInvoiceEqualsDelivery) {
      // Invoice (Factuur)
      if (customerInvoiceStreet !== "") {
        customer.invoice_street = customerInvoiceStreet;
      } else {
        errors['customer_invoice_street'] = 'Straatnaam is een verplicht veld';
        props.formErrors['customer_invoice_street'] = 'Straatnaam is een verplicht veld';
      }

      if (customerInvoiceNumber !== "") {
        customer.invoice_number = customerInvoiceNumber;
      } else {
        errors['customer_invoice_number'] = 'Huisnummer en/of bus is een verplicht veld';
        props.formErrors['customer_invoice_number'] = 'Huisnummer en/of bus is een verplicht veld';
      }

      if (customerInvoiceZip !== "") {
        customer.invoice_zip = customerInvoiceZip;
      } else {
        errors['customer_invoice_zip'] = 'Postcode is een verplicht veld';
        props.formErrors['customer_invoice_zip'] = 'Postcode is een verplicht veld';
      }

      if (customerInvoiceCity !== "") {
        customer.invoice_city = customerInvoiceCity;
      } else {
        errors['customer_invoice_city'] = 'Gemeente is een verplicht veld';
        props.formErrors['customer_invoice_city'] = 'Gemeente is een verplicht veld';
      }
    } else {
      customer.invoice_street = customerDeliveryStreet;
      customer.invoice_number = customerDeliveryNumber;
      customer.invoice_zip = customerDeliveryZip;
      customer.invoice_city = customerDeliveryCity;
    }

    console.log("errors: " + JSON.stringify(errors));

    if (Object.keys(errors).length > 0) {
      formIsValid = false;
    }
    setOrderErrors(errors);

    return formIsValid;
  }

  function testing(event) {

    console.log("testing");
    console.log("event: " + event);
    console.log("event.target: " + event.target);

    //props.testLogin(event);
    //let formData = new FormData(event)

    //let customerEmail = formData.get("customer_email");
    //console.log("customerEmail: " + customerEmail);


    //ApiRequest.axiosInstance({ method: "post", url: "/test.php", data: formData, headers: {} })
    //.then(res => {
    //  console.log("testing res: "  + JSON.stringify(res));
    //})
    //.catch((err) => {
    //  console.log("error testing: " + err);
    //});

  }

  function changeBestellen() {
    let nErrors = Object.keys(props.formErrors).length;
    console.log("errors: " + nErrors);
    let element = document.getElementById("mylabel");
    console.log("element: " + element);
    if(element !== null) {
      let hidden = element.getAttribute("hidden");
      if(nErrors === 0) {
        element.removeAttribute("hidden");
        bestellenKnop = true;
        document.getElementById("btnOrder").disabled = true;
        document.getElementById("algv_checkbox").disabled = true;
      }
    }
  }

  function checkHasDoors() {
    props.slots.forEach(slot => {
      if (slot.moduleData !== undefined && slot.moduleData !== null) {
        let hd = slot.moduleData.module_has_door;
        if(hd !== undefined && hd !== null && hd !== '0') {
          hasDoors = true;
        }
      }
    });
  }

  function showDeliveryText() {
    console.log("settings: " + props.settings.delivery_offset);
    return props.settings.delivery_offset;
  }

  function showInnerMaterial(hasDoors) {
    if(hasDoors) {
      return(
        <>
        <Row noGutters>
          <div className="colorpicker-container">
            <h5>Binnenkant</h5>
            <h6 id="inner-color-hover-display">Geselecteerde kleur: {props.closetProps.innerMaterial === null ? "Geen" : props.closetProps.innerMaterial.material_base_name}</h6>
            {props.materials.map((material) => {
              //console.log(props.closetProps)
              if (!material.material_types.includes("inner")) return

              if (props.closetProps.innerMaterial !== null && material.material_base_name === props.closetProps.innerMaterial.material_base_name)
                return (
                  <OverlayTrigger key={material.material_base_name + "-inner"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='180vw' src={formatURL(material.material_texture_path)} alt=""/><p>{material.material_base_name}</p></Popover>}>
                    <span
                      key={material.material_base_name + "-inner"}
                      className="dot inside active"
                      id={material.material_base_name}
                      style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("inner-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("inside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        setMaterial(material, "in");
                      }} />
                  </OverlayTrigger>);
              else
                return (
                  <OverlayTrigger key={material.material_base_name + "-inner"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img height='180vw' src={formatURL(material.material_texture_path)} alt=""/><p>{material.material_base_name}</p></Popover>}>
                    <span
                      key={material.material_base_name + "-inner"}
                      className="dot inside"
                      id={material.material_base_name}
                      style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                      onClick={(e) => {

                        const dots = document.getElementsByClassName('dot');

                        const materialNameDisplay = document.getElementById("inner-color-hover-display")
                        materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                        for (var i = 0; i < dots.length; i++) {
                          const dot = dots[i];
                          if (dot.classList.contains("inside"))
                            dot.classList.remove('active')
                        }

                        e.target.classList.add('active')

                        setMaterial(material, "in");
                      }}>
                    </span>
                  </OverlayTrigger>);
            }
            )}
          </div>
        </Row>
        </>
      )
    }
  }

  function schuinenkantachter(roomType) {
    if(roomType === "Schuin achter") {
      return(
        <>
          <hr/>
          <Row noGutters>
            <Col lg={4}>
              <p>Hoogte achterkant (A): <button onMouseEnter={() => setShowSchuinenkant(true)} onMouseLeave={() => setShowSchuinenkant(false)}>?</button></p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("D", e)} value={inputBoxDimensions.D} min={props.validationSizes.minDepth} max={props.validationSizes.maxDepth} aria-label='Kamer Diepte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>
          <Row noGutters>
            <Col lg={4}>
              <p>Lengte achterkant (B): <button onMouseEnter={() => setShowSchuinenkant(true)} onMouseLeave={() => setShowSchuinenkant(false)}>?</button></p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("D", e)} value={inputBoxDimensions.D} min={props.validationSizes.minDepth} max={props.validationSizes.maxDepth} aria-label='Kamer Diepte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
              {showSchuinenkant && (<div><img src="https://testapi.korpusweb.be/sketch3.jpg" alt=""/></div>)}
            </Col>
          </Row>
          <hr/>
        </>
      );
    }
  }
  
  function showExactHeight(roomType) {
    if(roomType === "Alleenstaand Zwevend") {
      return(
        <>
        <Row noGutters>
          <Col lg={4}>
            <p>Exacte hoogte kast:</p>
          </Col>
          <Col lg={8}>
            <InputGroup className='mb-3 no-bottom-margin'>
              <FormControl type='number' onChange={(e) => _validateInputs("KH", e)} value={(inputBoxDimensions.H - props.khHeight)} min={props.validationSizes.minHeightZw - props.khHeight} max={props.validationSizes.maxHeightZw - props.khHeight} aria-label='Kamer Hoogte' aria-describedby='basic-addon2' />
              <InputGroup.Append>
                <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
            <div className='size-input-validation-error'></div>
          </Col>
        </Row>
        <Row noGutters>
          <Col lg={4}>
            <p>Hoogte:</p>
          </Col>
          <Col lg={8}>
            <InputGroup className='mb-3 no-bottom-margin'>
              <FormControl type='number' onChange={(e) => _validateInputs("H", e)} value={inputBoxDimensions.H} min={props.validationSizes.minHeightZw} max={props.validationSizes.maxHeightZw} aria-label='Kamer Hoogte' aria-describedby='basic-addon2' disabled={true} />
              <InputGroup.Append>
                <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
            <div className='size-input-validation-error'></div>
          </Col>
        </Row>
        </>
      );
    }
    else {
      return(
        <Row noGutters>
          <Col lg={4}>
            <p>Hoogte:</p>
          </Col>
          <Col lg={8}>
            <InputGroup className='mb-3 no-bottom-margin'>
              <FormControl type='number' onChange={(e) => _validateInputs("H", e)} value={inputBoxDimensions.H} min={props.validationSizes.minHeight} max={props.validationSizes.maxHeight} aria-label='Kamer Hoogte' aria-describedby='basic-addon2' />
              <InputGroup.Append>
                <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
            <div className='size-input-validation-error'></div>
          </Col>
        </Row>
      );
    }
  }

  function handleOrderPopup(show) {
    let errors = {};
    props.generateOrderJSON(errors);
    if (Object.keys(errors).length > 0) {
      setOrderErrors(errors);
      setShowErrors(true);
      return;
    }

    if (!show) {
      props.clearCustomerFormErrors();
    }

    setLoading(false);
    setShowOrderPopUp(show)
    setHideInvoiceAddress(!show ? true : hideInvoiceAddress)
  }

  function toggleHideInvoiceAddress() {
    setHideInvoiceAddress(!hideInvoiceAddress)
  }

  function toggleButtonOrder() {
    if(document.getElementById("algv_checkbox").checked) {
			document.getElementById("btnOrder").disabled = false;
    }
    else {
			document.getElementById("btnOrder").disabled = true;
    }
  }

  function _hasNoSingleModules() {
    const modules = props.slots

    for (let i = 0; i < modules.length; i++) {
      if (modules[i]?.moduleData != null && modules[i]?.moduleData?.module_size === 1)
        return false;
    }

    return true;
  }

  function _hasNoDoubleModules() {
    const modules = props.slots

    for (let i = 0; i < modules.length; i++) {
      if (modules[i]?.moduleData != null && modules[i]?.moduleData?.module_size === 2)
        return false;
    }

    return true;
  }


  // Set Active Module / Handgreep
  function _setActive(e, type, object) {
    console.log("_setActive");
    const target = e.target;

    const cardDecks = target.closest(".row").querySelectorAll(".card-deck");
    cardDecks.forEach((cardDeck) => {
      const cards = cardDeck.querySelectorAll(".card");
      cards.forEach((card) => {
        card.childNodes[0].classList.add("card-hide");
      });
    });

    if (target.classList.contains("card")) {
      target.childNodes[0].classList.remove("card-hide");
    } else {
      const card = target.closest(".card");
      card.childNodes[0].classList.remove("card-hide");
    }

    switch (type) {
      case 'Module':
        console.log("SidePanel case 'Module'");
        props.setActiveModule(object);
        props.setModuleClicked(true);
        break;
      case 'Greep':
        props.setActiveGrip(object)
        break;
      case 'Lade':
        props.setActiveLade(object)
        break;
      case 'Scharnier':
        // props.setActiveModule(object)
        break;
      default:
        break;
    }
  }

  function checkPlintBoven() {
    if(props.room.room_type === "Alleenstaand Zwevend") {
      plintBoven = "Dikte tablet:";
      plintOnder = "Hoogte onder kast:";
    }
  }

  function _validateInputs(type, e) {
    console.log("hoogte: " + type + " / " + inputBoxDimensions.H + " / " + e.target.value + " / " + (inputBoxDimensions.H - props.khHeight));
    if(type === "MB") {
      setModuleBreedte(""+e.target.value);
      props.setBoxDimensions("MB", ""+e.target.value);
      inputBoxDimensions.MB = ""+e.target.value;
    }
    else {
      const errorMessage = e.target.closest(".col-lg-8").querySelector(".size-input-validation-error");
      errorMessage.innerHTML = "";
      e.target.style.border = "";

      const value = +e.target.value;
      const min = +e.target.getAttribute("min");
      const max = +e.target.getAttribute("max");

      const inputTemp = { ...inputBoxDimensions }
      if (value > max) {
        // Error Styling + Display
        e.target.style.border = "1px solid #ff0000";
        errorMessage.innerHTML = `Geef een waarde tussen ${min} en ${max}`;
        inputTemp[type] = value > max ? max : min;
      } else if (value < min) {
        e.target.style.border = "1px solid #ff0000";
        errorMessage.innerHTML = `Geef een waarde tussen ${min} en ${max}`;
        inputTemp[type] = value
      } else {
        errorMessage.innerHTML = "";
        e.target.style.border = "";
        inputTemp[type] = value
      }

      const hhh = inputBoxDimensions.H - props.khHeight;
      if(type === "KH") {
        if(hhh > value) {
          inputTemp["H"] = inputTemp["H"] - 1;
        }
        else {
          inputTemp["H"] = inputTemp["H"] + 1;
        }
      }

      setInputBoxDimensions(inputTemp);
      console.log("H en KH: " + props.boxDimensions.H + " - " + props.boxDimensions.KH + " - " + inputTemp["H"]);
      console.log("value: " + value);
    
      props.setBoxDimensions(type, value);
      if(type === "KH") {
        props.setBoxDimensions("H", inputTemp["H"]);
      }
    }

    const errorElements = document.getElementsByClassName("size-input-validation-error");
    let allowNext = true;
    for (var i = 0; i < errorElements.length; i++) {
      const element = errorElements[i]
      if (element.innerHTML !== "") {
        allowNext = false;
      }
    }

    setPageControlAllowNext(allowNext)
  }

  let disableLeft = false;
  let disableRight = false;
  let disableTop = false;
  let disableBottom = true;

  switch (props.room.room_type) {
    case "Alleenstaand":
      disableLeft = true
      disableRight = true
      disableTop = true
      break;
    case "Alleenstaand Plafond":
      disableLeft = true
      disableRight = true
      break;
    case "Alleenstaand Zwevend":  
      disableLeft = false
      disableRight = false
      disableTop = false
      disableBottom = true
      break;
    case "Links open":
      disableLeft = true
      disableTop = true
      break;
    case "Links open Plafond":
      disableLeft = true
      break;
    case "Rechts open":
      disableRight = true
      disableTop = true
      break;
    case "Rechts open Plafond":
      disableRight = true
      break;
    case "Ingebouwd":
      disableTop = true
      break;
    case "Ingebouwd Plafond":
      break;
    case "Schuin achter":
      disableLeft = true
      disableRight = true
      disableTop = true
      break;      
    default:
      break;
  }


  switch (props.designstep) {
    case 1:
      checkHasDoors();
      checkPlintBoven();
      console.log("case 1 hasDoors: " + hasDoors);
      panelTitle = "1. Afmetingen";
      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <Col lg={4}>
              <p>Breedte:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("B", e)} value={inputBoxDimensions.B} min={props.validationSizes.minWidth} max={props.validationSizes.maxWidth} aria-label='Kamer Breedte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          {showExactHeight(props.room.room_type)}

          <Row noGutters>
            <Col lg={4}>
              <p>Diepte:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3 no-bottom-margin'>
                <FormControl type='number' onChange={(e) => _validateInputs("D", e)} value={inputBoxDimensions.D} min={props.validationSizes.minDepth} max={props.validationSizes.maxDepth} aria-label='Kamer Diepte' aria-describedby='basic-addon2' />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          {schuinenkantachter(props.room.room_type)}

          <Row noGutters>
            <Col lg={4}>
              <p>Module breedte: <button onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)}>?</button></p>
            </Col>
            <Col lg={5}>
              <InputGroup className="mb-3 no-bottom-margin">
                <FormCheck inline type="radio" label="Maximum front breedte" value="60" name="moduleBreedte" checked={moduleBreedte === "60"} onChange={onModuleBreedteChange}/>
                <FormCheck inline type="radio" label="Basis front breedte" value="52" name="moduleBreedte" checked={moduleBreedte === "52"} onChange={onModuleBreedteChange}/>
                <FormCheck inline type="radio" label="Minimale front breedte" value="45" name="moduleBreedte" checked={moduleBreedte === "45"} onChange={onModuleBreedteChange}/>
                {isShown && (<div>De maximum module breedte is 60cm, de basis 52cm en het minimum 45cm.</div>)}
              </InputGroup>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Afwerking Links:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("AL", e)} value={inputBoxDimensions.AL} min={props.validationSizes.minLeft} max={props.validationSizes.maxLeft} aria-label='Afwerking Links' aria-describedby='basic-addon2' disabled={disableLeft ? true : ""} />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>Afwerking Rechts:</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("AR", e)} value={inputBoxDimensions.AR} min={props.validationSizes.minRight} max={props.validationSizes.maxRight} aria-label='Afwerking Rechts' aria-describedby='basic-addon2' disabled={disableRight ? true : ""} />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>{plintBoven}</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("PB", e)} value={inputBoxDimensions.PB} min={props.validationSizes.minBottom} max={props.validationSizes.maxBottom} aria-label='Plint Boven' aria-describedby='basic-addon2' disabled={disableTop ? true : ""} />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row noGutters>
            <Col lg={4}>
              <p>{plintOnder}</p>
            </Col>
            <Col lg={8}>
              <InputGroup className='mb-3'>
                <FormControl type='number' onChange={(e) => _validateInputs("PO", e)} value={inputBoxDimensions.PO} min={props.validationSizes.minTop} max={props.validationSizes.maxTop} aria-label='Plint Onder' aria-describedby='basic-addon2' disabled={disableBottom ? true : ""} />
                <InputGroup.Append>
                  <InputGroup.Text id='basic-addon2'>cm</InputGroup.Text>
                </InputGroup.Append>
              </InputGroup>
              <div className='size-input-validation-error'></div>
            </Col>
          </Row>

          <Row>
            <Col lg={4}>
              <p>Muurkleur:</p>
            </Col>
            <Col lg={8}>
              <Form.Control type='color' onChange={e => props.setWallColor(e.target.value)} />
            </Col>
          </Row>
        </Container>
      );
      break;
    case 2:
      checkHasDoors();
      console.log("case 2 hasDoors: " + hasDoors);
      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>Lijst van verschillende mogelijke modules.</p>
          </Row>
          {/* NOTE: Pas de code hieronder aan (is placeholder code voor style), LET WEL OP! Als ik een bepaalde className gebruik voor style, dan gebruik die ook in het 'echte' design */}
          <Row noGutters className='row-card-container'>
            <Col>
              <Tabs defaultActiveKey='single' id='module-tab'>
                <Tab eventKey='single' title='Enkel'>
                  <Tabs defaultActiveKey='open' id="single-doors-tab">
                    <Tab eventKey='open' title='Zonder deur'>
                      <CardGroup>
                        {filteredModules.single.open.map((module, index) => {
                          return (
                            <OverlayTrigger key={module.module_id} placement={index >= 8 ? "top" : "bottom"} delay={{ show: 250, hide: 150 }} overlay={<Popover style={{ textAlign: "center" }}><img height='300vh' src={formatURL(module.module_model_thumbnail_path)} alt="" /><p>{module.module_description}</p></Popover>}>
                              <Card onClick={(e) => _setActive(e, "Module", module)}>
                                <div className='card-active card-hide'>
                                  <FaCheck />
                                </div>
                                <Card.Img src={formatURL(module.module_model_thumbnail_path)} />
                              </Card>
                            </OverlayTrigger>
                          )
                        })}
                      </CardGroup>
                    </Tab>
                    <Tab eventKey='left' title='Deur links'>
                      <CardGroup>
                        {filteredModules.single.doorLeft.map((module, index) => {
                          return (
                            <OverlayTrigger key={module.module_id} placement={index >= 8 ? "top" : "bottom"} delay={{ show: 250, hide: 150 }} overlay={<Popover style={{ textAlign: "center" }}><img height='300vh' src={formatURL(module.module_model_thumbnail_path)} alt="" /><p>{module.module_description}</p></Popover>}>
                              <Card onClick={(e) => _setActive(e, "Module", module)}>
                                <div className='card-active card-hide'>
                                  <FaCheck />
                                </div>
                                <Card.Img src={formatURL(module.module_model_thumbnail_path)} />
                              </Card>
                            </OverlayTrigger>
                          )
                        })}
                      </CardGroup>
                    </Tab>
                    <Tab eventKey='right' title='Deur rechts'>
                      <CardGroup>
                        {filteredModules.single.doorRight.map((module, index) => {
                          return (
                            <OverlayTrigger key={module.module_id} placement={index >= 8 ? "top" : "bottom"} delay={{ show: 250, hide: 150 }} overlay={<Popover style={{ textAlign: "center" }}><img height='300vh' src={formatURL(module.module_model_thumbnail_path)} alt="" /><p>{module.module_description}</p></Popover>}>
                              <Card onClick={(e) => _setActive(e, "Module", module)}>
                                <div className='card-active card-hide'>
                                  <FaCheck />
                                </div>
                                <Card.Img src={formatURL(module.module_model_thumbnail_path)} />
                              </Card>
                            </OverlayTrigger>
                          )
                        })}
                      </CardGroup>
                    </Tab>
                  </Tabs>
                </Tab>

                <Tab eventKey='double' title='Dubbel'>
                  <Tabs defaultActiveKey='open' id="double-doors-tab">
                    <Tab eventKey='open' title='Zonder deuren'>
                      <CardGroup>
                        {filteredModules.double.open.map((module, index) => {
                          // console.log(module)
                          return (
                            <OverlayTrigger key={module.module_id} placement={index >= 8 ? "top" : "bottom"} delay={{ show: 250, hide: 150 }} overlay={<Popover style={{ textAlign: "center" }}><img height='300vh' src={formatURL(module.module_model_thumbnail_path)} alt=""/><p>{module.module_description}</p></Popover>}>
                              <Card key={module.module_id} onClick={(e) => _setActive(e, "Module", module)}>
                                <div className='card-active card-hide'>
                                  <FaCheck />
                                </div>
                                <Card.Img src={formatURL(module.module_model_thumbnail_path)} />
                              </Card>
                            </OverlayTrigger>
                          )
                        })}
                      </CardGroup>
                    </Tab>
                    <Tab eventKey='doors' title='Met deuren'>
                      <CardGroup>
                        {filteredModules.double.doors.map((module, index) => {
                          // console.log(module)
                          return (
                            <OverlayTrigger key={module.module_id} placement={index >= 8 ? "top" : "bottom"} delay={{ show: 250, hide: 150 }} overlay={<Popover style={{ textAlign: "center" }}><img height='300vh' src={formatURL(module.module_model_thumbnail_path)} alt=""/><p>{module.module_description}</p></Popover>}>
                              <Card key={module.module_id} onClick={(e) => _setActive(e, "Module", module)}>
                                <div className='card-active card-hide'>
                                  <FaCheck />
                                </div>
                                <Card.Img src={formatURL(module.module_model_thumbnail_path)} />
                              </Card>
                            </OverlayTrigger>
                          )
                        })}
                      </CardGroup>
                    </Tab>
                  </Tabs>
                </Tab>
              </Tabs>
            </Col>
          </Row>
        </Container >
      );
      panelTitle = "2. Modules";
      break;
    case 3:
      checkHasDoors();
      console.log("case 3 hasDoors: " + hasDoors);
      panelContent = (
        <Container fluid>
          <Row noGutters>
            <p>In welke kleur wil je je kast?</p>
          </Row>

          {showInnerMaterial(hasDoors)}

          <Row noGutters>
            <div className="colorpicker-container">
              <h5>Buitenkant</h5>
              <h6 id="outer-color-hover-display">Geselecteerde kleur: {props.closetProps.outerMaterial === null ? "geen" : props.closetProps.outerMaterial.material_base_name}</h6>
              {props.materials.map((material) => {
                if (!material.material_types.includes("outer")) return
                if (props.closetProps.outerMaterial !== null && material.material_base_name === props.closetProps.outerMaterial.material_base_name)
                  return (
                    <OverlayTrigger key={material.material_base_name + "-outer"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img height='180vw' src={formatURL(material.material_texture_path)} alt=""/> <p>{material.material_base_name}</p></Popover>}>
                      <span
                        key={material.material_base_name + "-outer"}
                        id={material.material_base_name}
                        className="dot outside active"
                        style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                        onClick={(e) => {

                          const dots = document.getElementsByClassName('dot');

                          const materialNameDisplay = document.getElementById("outer-color-hover-display")
                          materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                          for (var i = 0; i < dots.length; i++) {
                            const dot = dots[i];
                            if (dot.classList.contains("outside"))
                              dot.classList.remove('active')
                          }

                          e.target.classList.add('active')

                          setMaterial(material, "out");
                        }}>
                      </span>
                    </OverlayTrigger>
                  );
                else
                  return (
                    <OverlayTrigger key={material.material_base_name + "-outer"} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img height='180vw' src={formatURL(material.material_texture_path)} alt=""/><p>{material.material_base_name}</p></Popover>}>
                      <span
                        key={material.material_base_name + "-outer"}
                        id={material.material_base_name}
                        className="dot outside"
                        style={{ backgroundImage: "url(\"" + formatURL(material.material_texture_path) + "\")" }}
                        onClick={(e) => {

                          const dots = document.getElementsByClassName('dot');

                          const materialNameDisplay = document.getElementById("outer-color-hover-display")
                          materialNameDisplay.innerText = "Geselecteerde kleur: " + e.target.id

                          for (var i = 0; i < dots.length; i++) {
                            const dot = dots[i];
                            if (dot.classList.contains("outside"))
                              dot.classList.remove('active')
                          }

                          e.target.classList.add('active')

                          setMaterial(material, "out");
                        }}>
                      </span>
                    </OverlayTrigger>
                  );
              })}
            </div>
          </Row>
        </Container>
      );
      panelTitle = "3. Materialen";
      break;
    case 4:
      checkHasDoors();
      console.log("case 4 hasDoors: " + hasDoors);
      let filtered = props.featureTypes.filter(obj => {
        return obj.feature_type_id === 1;
      });
      let ftypes = props.features['Greep'].filter(obj => {
        return obj.feature_type === 1;
      });

      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>Je kast is bijna klaar… Het enige wat je nog hoeft te doen, is de extra's kiezen.</p>
          </Row>
          <Row noGutters className='row-card-container'>
            <div>
              <h5>Greep</h5>

              { props.featureTypes.map(featureType => {
                  if (hasDoors) {
                    if (featureType.feature_type_id === 1) {
                      return (
                        <CardGroup>
                          {props.features['Greep'].map(feature => {
                            if (props.closetProps.activeGrip !== null && feature.feature_id === props.closetProps.activeGrip.feature_id)
                              return (
                                <OverlayTrigger key={feature.feature_id} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='150vw' src={formatURL(feature.feature_thumbnail_path)} alt=""/></Popover>}>
                                  <Card className="card-flex-40p" key={feature.feature_id} onClick={(e) => _setActive(e, 'Greep', feature)}>
                                    <div className='card-active'>
                                      <FaCheck />
                                    </div>
                                    <Card.Img src={formatURL(feature.feature_thumbnail_path)} />
                                    <Card.Body>{feature.feature_name}</Card.Body>
                                  </Card>
                                </OverlayTrigger>)
                            else
                              return (
                                <OverlayTrigger key={feature.feature_id} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='150vw' src={formatURL(feature.feature_thumbnail_path)} alt=""/></Popover>}>
                                  <Card className="card-flex-40p" key={feature.feature_id} onClick={(e) => _setActive(e, 'Greep', feature)}>
                                    <div className='card-active card-hide'>
                                      <FaCheck />
                                    </div>
                                    <Card.Img src={formatURL(feature.feature_thumbnail_path)} />
                                    <Card.Body>{feature.feature_name}</Card.Body>
                                  </Card>
                                </OverlayTrigger>)
                          })}
                        </CardGroup>
                    )
                    }
                  }
                }
              )}
              {
                filtered.map(obj => {
                  if(!hasDoors) {
                    return (<p>Kies minstens 1 module met deuren om een greep te kiezen</p>);
                  }
                })
              }

            </div>
          </Row>
        </Container >
      );
      panelTitle = "4. Extra's";
      break;
    case 5:
      let hasDrawer = false;
      props.slots.forEach(slot => {
        if (slot.moduleData !== undefined && slot.moduleData !== null) {
          let hd = slot.moduleData.module_has_drawer;
          if(hd !== undefined && hd !== null && hd !== '0') {
            hasDrawer = true;
          }
        }
      });
      let filteredL = props.featureTypes.filter(obj => {
        return obj.feature_type_id === 2;
      });

      panelContent = (
        <Container fluid className="overflow-scroll">
          <Row noGutters>
            <p>Je kast is bijna klaar… Het enige wat je nog hoeft te doen, is de extra's kiezen.</p>
          </Row>
          <Row noGutters className='row-card-container'>
            <div>
              <h5>Lade</h5>
              <p>Kies minstens 1 module met lades om een lade te kiezen.<br/><b>Opgelet:</b> Kleur van de laden verandert niet in het 3D-ontwerp online</p>
              { props.featureTypes.map(featureType => {
                  if (hasDrawer) {
                    if (featureType.feature_type_id === 2) {
                      return (
                        <CardGroup>
                          {props.features['Lade'].map(feature => {
                            if (props.closetProps.activeLade !== null && feature.feature_id === props.closetProps.activeLade.feature_id)
                              return (
                                <OverlayTrigger key={feature.feature_id} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='150vw' src={formatURL(feature.feature_thumbnail_path)} alt=""/></Popover>}>
                                  <Card className="card-flex-40p" key={feature.feature_id} onClick={(e) => _setActive(e, 'Lade', feature)}>
                                    <div className='card-active'>
                                      <FaCheck />
                                    </div>
                                    <Card.Img src={formatURL(feature.feature_thumbnail_path)} />
                                    <Card.Body>{feature.feature_name}</Card.Body>
                                  </Card>
                                </OverlayTrigger>)
                            else
                              return (
                                <OverlayTrigger key={feature.feature_id} placement="top" delay={{ show: 250, hide: 150 }} overlay={<Popover><img width='150vw' src={formatURL(feature.feature_thumbnail_path)} alt=""/></Popover>}>
                                  <Card className="card-flex-40p" key={feature.feature_id} onClick={(e) => _setActive(e, 'Lade', feature)}>
                                    <div className='card-active card-hide'>
                                      <FaCheck />
                                    </div>
                                    <Card.Img src={formatURL(feature.feature_thumbnail_path)} />
                                    <Card.Body>{feature.feature_name}</Card.Body>
                                  </Card>
                                </OverlayTrigger>)
                          })}
                        </CardGroup>
                    )
                    }
                  }  
                }
              )}
            </div>
          </Row>
        </Container >
      );
      panelTitle = "4. Extra's";
      break;

    case 6:
      bestellenKnop = true;

      let hasDoors2 = false;
      props.slots.forEach(slot => {
        if (slot.moduleData !== undefined && slot.moduleData !== null) {
          let hd = slot.moduleData.module_has_door;
          if(hd !== undefined && hd !== null && hd !== '0') {
            hasDoors2 = true;
          }
        }
      });
      let hasDrawer2 = false;
      props.slots.forEach(slot => {
        if (slot.moduleData !== undefined && slot.moduleData !== null) {
          let hd = slot.moduleData.module_has_drawer;
          if(hd !== undefined && hd !== null && hd !== '0') {
            hasDrawer2 = true;
          }
        }
      });


      panelContent = (
        <Container fluid className="overflow-scroll">
          <Alert variant="success">Totaalprijs inclusief 21% BTW.<br/>Verzending is gratis.<br/>{showDeliveryText()}</Alert>
		  <Row noGutters>
            <p>De kast is ontworpen, bestellen maar!</p>
          </Row>
          <div className="summary">
            <h6>Kamer</h6>
            <p>Breedte: {props.boxDimensions.B}cm</p>
            <p>Hoogte: {props.boxDimensions.H}cm</p>
            <p>Diepte (Kast): {props.boxDimensions.D}cm</p>
            <p>Module breedte: {props.boxDimensions.MB}</p>
            <p>Afwerking (L): {props.boxDimensions.AL}cm</p>
            <p>Afwerking (R): {props.boxDimensions.AR}cm</p>
            <p>Plint (B): {props.boxDimensions.PB}cm</p>
            <p>Plint (O): {props.boxDimensions.PO}cm</p>

            <br />

            <h6>Modules</h6>
            <p>Enkel: {_hasNoSingleModules() ? 'Geen' : ''}</p>
            <CardGroup>
              {props.slots.map((module, index) => {
                return module?.moduleData == null || module?.moduleData?.module_size !== 1 ? null : <Card className="card-flex-10p" key={index}>
                  <Card.Img src={formatURL(module?.moduleData?.module_model_thumbnail_path)} title={module?.moduleData?.module_name} alt={module?.moduleData?.module_name} />
                </Card>
              })}
            </CardGroup>

            <p>Dubbel: {_hasNoDoubleModules() ? 'Geen' : ''}</p>
            <CardGroup>
              {props.slots.map((module, index) => {
                return module?.moduleData == null || module?.moduleData?.module_size !== 2 ? null : <Card key={index}>
                  <Card.Img src={formatURL(module?.moduleData?.module_model_thumbnail_path)} title={module?.moduleData?.module_name} alt={module?.moduleData?.module_name} />
                </Card>
              })}
            </CardGroup>

            <br />

            <h6>Materialen<a href="#" onClick={() => { testing() }}>:</a></h6>
            <p>Binnenkant: {props.closetProps.innerMaterial?.material_base_name ?? "Geen"}</p>
            <p>Buitenkant: {props.closetProps.outerMaterial?.material_base_name ?? "Geen"}</p>

            <br />

            <h6>Extra's</h6>
            <CardGroup>
              {(() => {
                if(hasDoors2) {
                return (
                  <Card className="card-flex-40p">
                    <Card.Title>Greep</Card.Title>
                    <Card.Img src={formatURL(props.activeGrip?.feature_thumbnail_path)} title={props.activeGrip?.feature_name + " (" + props.activeGrip?.feature_type_name + ")"} alt={props.activeGrip?.feature_name + " (" + props.activeGrip?.feature_type_name + ")"} />
                    <Card.Body>{props.activeGrip?.feature_name}</Card.Body>
                  </Card>
                )
                }
              }
              )()}
              {(() => {
                if(hasDrawer2) {
                return (
                  <Card className="card-flex-40p">
                    <Card.Title>Lade</Card.Title>
                    <Card.Img src={formatURL(props.activeLade?.feature_thumbnail_path)} title={props.activeLade?.feature_name + " (" + props.activeLade?.feature_type_name + ")"} alt={props.activeLade?.feature_name + " (" + props.activeLade?.feature_type_name + ")"} />
                    <Card.Body>{props.activeLade?.feature_name}</Card.Body>
                  </Card>
                )
                }
              }
              )()}
            </CardGroup>
          </div>

          <Modal show={showErrors} onHide={() => handleErrors(false)}>	
            <Modal.Header closeButton>	
              <Modal.Title>Fouten</Modal.Title>	
            </Modal.Header>	
            <Modal.Body>	
              {formatLines(orderErrors["order_error"])}	
            </Modal.Body>	
          </Modal>

          <Modal show={showLast} onHide={() => handleLast(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Mededeling:</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p></p>
              <Row>
                <Col>Uw ontwerp is opgeslagen, deze kan u terugvinden bij ‘mijn ontworpen kasten’.</Col>
              </Row>
              <p></p>
              <Row>
                <Col>
                <Button variant='primary' id="btnOntwKasten" onClick={event =>  window.parent.location.href='https://bouwjekast.be/webshop/mijn-kasten/'}>
                Ga naar mijn ontworpen kasten
              </Button>
                </Col>
                <Col>
                <Button variant='primary' id="btnNieuwOntwerp" onClick={event => window.parent.location.href='https://bouwjekast.be/bouw-je-kast/'}>
                Nieuw ontwerp
              </Button>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>

          <Modal show={showOrderPopup} onHide={() => handleOrderPopup(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Accountgegevens</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form method='POST' encType='multipart/form-data' onSubmit={handleSubmit}>
              {/*
                <Form.Group>
                  <Form.Control type='text' placeholder='Naam' name='customer_name' />
                  <span className={props.formErrors["customer_name"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_name"]}</span>
                </Form.Group>
              */}
                <Form.Group>
                  <Form.Control type='email' placeholder='E-mailadres' name='customer_email' />
                  <span className={props.formErrors["customer_email"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_email"]}</span>
                </Form.Group>
                <Form.Group>
                  <Form.Control type='email' placeholder='Herhaal E-mailadres' name='herhaal_email' />
                  <span className={props.formErrors["herhaal_email"] ? "form-error" : "form-error-hidden"}>{props.formErrors["herhaal_email"]}</span>
                </Form.Group>
              {/*  
				        <Form.Group>
                  <Form.Control type='text' placeholder='Telefoon' name='customer_phone' />
                  <span className={props.formErrors["customer_phone"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_phone"]}</span>
                </Form.Group>
                <Form.Group>
                  <Form.Control type='text' placeholder='BTW-nummer' name='customer_btw' />
                  <span className={props.formErrors["customer_btw"] ? "form-error" : "form-error-hidden"}>{props.formErrors["customer_btw"]}</span>
                </Form.Group>
              */}  
                {/* Start Bezorg Adres */}
              {/*  
                <h5>Bezorgadres</h5>
                <Form.Group>
                  <Form.Control type='text' placeholder='Straatnaam' name='customer_delivery_street' />
                  <span className={props.formErrors['customer_delivery_street'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_street']}</span>
                </Form.Group>
                <Form.Group>
                  <Form.Control type='text' placeholder='Huisnummer & Bus' name='customer_delivery_number' />
                  <span className={props.formErrors['customer_delivery_number'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_number']}</span>
                </Form.Group>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Control type='text' placeholder='Postcode' name='customer_delivery_zip' />
                      <span className={props.formErrors['customer_delivery_zip'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_zip']}</span>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group>
                      <Form.Control type='text' placeholder='Gemeente' name='customer_delivery_city' />
                      <span className={props.formErrors['customer_delivery_city'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_delivery_city']}</span>
                    </Form.Group>
                  </Col>
                </Row>
              */}
                {/* Start Factuur Adres */}
              {/*  
                <h5>Factuuradres<Button className="btn-color" id="test"></Button></h5>
                <Form.Group>
                  <Form.Check type="checkbox" id="invoice_address_checkbox" name="customer_invoice_equals_delivery" label="Hetzelfde als bezorgadres" onChange={toggleHideInvoiceAddress} checked={hideInvoiceAddress} />
                </Form.Group>

                <div className={props.hideInvoiceAddress ? "card-hide" : ""}>
                  <Form.Group>
                    <Form.Control type='text' placeholder='Straatnaam' name='customer_invoice_street' />
                    <span className={props.formErrors['customer_invoice_street'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_street']}</span>
                  </Form.Group>
                  <Form.Group>
                    <Form.Control type='text' placeholder='Huisnummer & Bus' name='customer_invoice_number' />
                    <span className={props.formErrors['customer_invoice_number'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_number']}</span>
                  </Form.Group>
                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Control type='text' placeholder='Postcode' name='customer_invoice_zip' />
                        <span className={props.formErrors['customer_invoice_zip'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_zip']}</span>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Form.Control type='text' placeholder='Gemeente' name='customer_invoice_city' />
                        <span className={props.formErrors['customer_invoice_city'] ? 'form-error' : 'form-error-hidden'}>{props.formErrors['customer_invoice_city']}</span>
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              */}  
                <hr/>
                <Form.Group>
                  <Form.Control type='text' placeholder='Voor welke ruimte is uw kast:' name='ruimte' />
                </Form.Group>
                <hr/>

                <Form.Group>
                  <Form.Check type="checkbox" id="algv_checkbox" label="Akkoord met de algemene voorwaarden vermeld op de website" onChange={toggleButtonOrder}/>
                </Form.Group>

                <Button variant='primary' type='submit' id="btnOrder" disabled={bestellenKnop}>
                  Ontwerp opslaan
                </Button>
                {loading && (<div><PulseLoading/>Het ontwerp wordt weggeschreven. Dit kan enkele seconden duren.</div>)}
                {props.formErrors["order_error"] ? <Alert variant='danger'>{props.formErrors["order_error"]}</Alert> : null}
              </Form>
            </Modal.Body>
          </Modal>
        </Container>
      );
      panelTitle = "5. Bestelling plaatsen";
      break;
    default:
  }

  return (
    <div className='side-panel'>
      <Row style={{ justifyContent: "flex-end", paddingRight: "15px" }}>
        <DesignStepToolTip helps={props.helps} designstep={props.designstep} btnText="?" text="" />
      </Row>
      <Row className='side-panel-title-row'>
        <Col lg={6}>
          <h5>{panelTitle}</h5>
        </Col>
        { 
          props.designstep === 1 ? <Col lg={6}><DesignStepToolTip helps={props.helps} btnText="Hoe opmeten?" text={props.settings.howtomeasure}/></Col> : ''
        } 
        {
          props.designstep > 1 ? <Col lg={6}>
            <span id='totalProjectPrice'>Totaal: € {props.totalPrice}</span>
          </Col> :
            null
        }

      </Row>

      {panelContent}
      {pageControl}
    </div>
  );
}

export default SidePanel;
